import { ToolbarButton as _ToolbarButton } from './ToolbarButton.styled';

type ToolbarButtonProps = {
  active: boolean;
};

export const ToolbarButton = (props: ToolbarButtonProps) => {
  return <_ToolbarButton {...props} />;
};
